import React, {
  useContext,
  FunctionComponent,
  createContext,
  Context,
} from 'react';

export enum Theme {
  Default,
  Winter2020,
}

type Props = {
  children?: React.ReactNode;
};

export const ThemeContext: Context<Theme> = createContext<Theme>(Theme.Default);

const findByTheme =
  (theme: Theme) =>
  (child: any): boolean =>
    theme === child.props.theme;

export const Themable: FunctionComponent<Props> = ({ children }) => {
  const theme = useContext(ThemeContext);
  const filter = findByTheme(theme);

  const childArray = React.Children.toArray(children);
  const matchingElement = childArray.find(filter);

  const defaultElement = childArray[0] || null;

  return <>{matchingElement || defaultElement}</>;
};
